import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import "@/assets/scss/floating-vue.scss";

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(FloatingVue);
});
